/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Cta_LedeInputs */

const en_svc_n8n_cta_lede = /** @type {(inputs: Svc_N8n_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We will map it with you and tell you whether n8n, code or a mix of both is the right fit.`)
};

const lv_svc_n8n_cta_lede = /** @type {(inputs: Svc_N8n_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izprotam to kopā ar Jums un pasakām, vai labāk der n8n, kods vai abu apvienojums.`)
};

/**
* | output |
* | --- |
* | "We will map it with you and tell you whether n8n, code or a mix of both is the right fit." |
*
* @param {Svc_N8n_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_cta_lede = /** @type {((inputs?: Svc_N8n_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_cta_lede(inputs)
	return en_svc_n8n_cta_lede(inputs)
});